<template>
  <div>
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
        >
        </detail-entity-info>
      </div>
      <div class="right">
        <div class="field_left">
          <operator-select
              v-model="entity.id_operator"
              :options="operatorOptions"
              :disabled="isEdit || !isEditable || !$_loggedUser_canChangeOperator"
          >
          </operator-select>
          <text-input
              v-if="isEdit"
              id="key"
              :required="true"
              v-model="entity.key"
              :disabled="true"
              ref="keyref"
          >
            <translate class="translate">Klíč</translate>
          </text-input>
          <select-box
              id="type"
              :options="typeOptions"
              v-model="entity.type"
              :required="true"
              :disabled="isEdit || !isEditable"
              ref="typeref"
          >
            <translate class="translate">Typ</translate>
          </select-box>
        </div>
        <div class="field_right">
          <div class="field field_poster">
            <label
                for="user_image"
                :class="['profile_image', {is_image: hasImage}]"
                :title="'Nahrát fotku' | translate"
            >
              ?<img :src="userImage" v-if="hasImage">
              <img :src="entity.path" v-if="!hasImage && entity.path">
              <a
                  class="btn btn_action btn_delete"
                  :title="'Smazat' | translate"
                  @click.prevent.stop="deleteImage"
                  v-if="hasImage && isEditable && isEdit"
                  v-translate>Smazat
              </a>
            </label>
            <input
                type="file"
                accept="image/*"
                name="user_image"
                id="user_image"
                class="input_file"
                data-multiple-caption="{count} files selected"
                v-if="uploadReady"
                @change="onFileChange"
                ref="user_image"
                :disabled="!isEditable"
            />
          </div>
          <Constraints v-if="entity.type" :constraint="constraint" :image_validity="image_validity" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Message from "../../../mixins/message";
import images from "../mixins/images";
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import OperatorSelect from "../../../common/OperatorSelect.vue";
import imageValidation from "../mixins/imageValidation";
import Constraints from "./Constraints.vue";

export default {
  name: "BasicForm",
  components: {DetailEntityInfo, OperatorSelect, Constraints},
  mixins: [Message, images, imageValidation],
  props: {
    entity: Object,
    isEdit: Boolean,
    isEditable: Boolean,
  },
  data() {
    return {
      operators: [],
      epgChannels: [],
      uploadReady: true,
      selectedFile: null,
    }
  },
  created(ImageService, OperatorService) {
    this.entityService = ImageService;
    this.operatorService = OperatorService;
    this.operatorService.getOperators()
        .then(data => {
          this.operators = data['operators']
        });
    this.entityService.getConstraints()
        .then((data) => {
          this.constraints = data.image_constraints;
        });
    if(!this.isEdit){
      this.entity.id_operator = this.$_loggedUser_selectedOperatorId;
    }
  },
  computed: {
    type(){
      return this.entity.type;
    },
    operatorOptions() {
      if (this.operators) {
        return [{id: null, text: this.$gettext('Nenastaven')},
          ...this.operators.map(value => ({
            id: value['id'],
            text: value['name']
          }))];
      } else {
        return [];
      }
    },
    hasImage() {
      return this.selectedFile
          || (this.entity.image !== null
              && this.entity.image !== ''
              && this.entity.image != 'null'
              && this.entity.image != undefined
              && this.entity.image != 'undefined');
    },
    userImage() {
      if (this.selectedFile) {
        return URL.createObjectURL(this.selectedFile);
      }
      return 'uploads/user_images/' + this.entity.image;
    },
    typeOptions() {
      return Object.keys(this.constraints).map(key => ({
        id: key,
        text: this.getTypeText(key)
      }));
    }
  },
  methods: {
    deleteImage() {
      for (const key in this.image_validity) {
        this.image_validity[key] = null;
      }
      this.selectedFile = null;
      this.entity.uploadData = null;
    },
    async onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.selectedFile = file
      await this.validateImageFile(this.selectedFile);
      this.entity.uploadData = file;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/images/forms/BasicForm.vue